var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _g, _g2, _path23, _path24, _path25;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgInProgressImage(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 200,
    height: 200,
    viewBox: "0 0 200 200",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.75 150.5C15.1307 150.5 16.25 149.381 16.25 148C16.25 146.619 15.1307 145.5 13.75 145.5C12.3693 145.5 11.25 146.619 11.25 148C11.25 149.381 12.3693 150.5 13.75 150.5Z",
    fill: "#C9CFD4"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M81.1249 167.25C119.302 167.25 150.25 136.302 150.25 98.125C150.25 59.9483 119.302 29 81.1249 29C42.9482 29 11.9999 59.9483 11.9999 98.125C11.9999 136.302 42.9482 167.25 81.1249 167.25Z",
    fill: "#EBEDEF"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M163.625 88.125C165.006 88.125 166.125 87.0057 166.125 85.625C166.125 84.2443 165.006 83.125 163.625 83.125C162.244 83.125 161.125 84.2443 161.125 85.625C161.125 87.0057 162.244 88.125 163.625 88.125Z",
    fill: "#C9CFD4"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M86.7501 30.875C92.1251 30.875 96.3751 26.5 96.3751 21.25C96.3751 26.625 100.75 30.875 106 30.875C100.625 30.875 96.3751 35.25 96.3751 40.5C96.5001 35.25 92.1251 30.875 86.7501 30.875Z",
    fill: "#C9CFD4"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M23.2577 85.121C21.9164 78.6825 25.9404 72.3782 32.3789 71.0369C38.8173 69.6955 45.1216 73.7196 46.463 80.158L23.2577 85.121Z",
    fill: "#EBEDEF"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M126.541 63.2568L147.869 163.858L79.326 178.478C78.6553 178.613 77.8505 178.747 77.1798 178.747C71.5462 178.881 66.5832 174.991 65.376 169.357L46.463 80.1578C45.1217 73.7193 38.8174 69.6953 32.3789 71.0366L112.457 54.0015C118.896 52.6602 125.2 56.8184 126.541 63.2568Z",
    fill: "white"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M77.4482 103.497L74.7655 104.034C68.8636 105.241 63.0958 101.485 61.8886 95.7175L61.3521 93.0348C60.1449 87.1329 63.9006 81.3651 69.6684 80.1579L72.3511 79.6214C78.253 78.4142 84.0208 82.1699 85.228 87.9377L85.7646 90.6204C87.1059 96.5223 83.3501 102.29 77.4482 103.497Z",
    fill: "#E4ECF9"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M76.5091 100.815L74.4971 101.352C69.9365 102.291 65.5101 99.4737 64.5711 94.9131L64.1687 92.9011C63.2298 88.3406 66.0466 83.9141 70.6072 82.9752L72.6192 82.5728C77.1798 81.6338 81.6062 84.4507 82.5451 89.0112L82.9476 91.0232C84.0206 95.4497 81.0697 99.8761 76.5091 100.815Z",
    fill: "white"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M123.145 103.757L66.2053 115.859L66.5957 117.696L123.535 105.593L123.145 103.757Z",
    fill: "#E4ECF9"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M125.042 112.743L68.1027 124.846L68.4931 126.682L125.433 114.58L125.042 112.743Z",
    fill: "#E4ECF9"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M126.911 121.599L69.9717 133.702L70.3621 135.539L127.302 123.436L126.911 121.599Z",
    fill: "#D0D8DC"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M97.3442 137.145L71.892 142.555L72.2824 144.391L97.7346 138.981L97.3442 137.145Z",
    fill: "#E4ECF9"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M126.911 121.599L69.9717 133.702L70.3621 135.539L127.302 123.436L126.911 121.599Z",
    fill: "#E4ECF9"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M116.397 72.4957L90.8141 77.9336L91.2045 79.7704L116.788 74.3325L116.397 72.4957Z",
    fill: "#D0D8DC"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M118.267 81.3522L92.6835 86.79L93.0739 88.6268L118.657 83.1889L118.267 81.3522Z",
    fill: "#D0D8DC"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M111.135 92.2246L94.6046 95.7383L94.995 97.575L111.526 94.0613L111.135 92.2246Z",
    fill: "#D0D8DC"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M88.5812 164.394C89.9226 170.833 85.8985 177.137 79.4601 178.479L159.538 161.443C165.977 160.102 170.001 153.798 168.66 147.359L88.5812 164.394Z",
    fill: "#EBEDEF"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M130.833 69.8296C116.213 60.306 96.6291 64.4642 87.1056 79.0848C77.582 93.7055 81.7402 113.289 96.3608 122.813C110.981 132.336 130.565 128.178 140.089 113.557C149.746 98.9367 145.588 79.3531 130.833 69.8296ZM134.321 109.802C126.944 121.203 111.652 124.422 100.385 117.045C88.9834 109.667 85.7642 94.3762 93.1416 83.1089C100.519 71.7074 115.81 68.4882 127.078 75.8656C138.479 83.1089 141.698 98.4002 134.321 109.802Z",
    fill: "#7B828E"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M141.851 110.957L138.418 116.244L148.543 122.819L151.976 117.531L141.851 110.957Z",
    fill: "#7B828E"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M185.963 143.335C183.012 147.761 177.11 149.103 172.683 146.152L153.1 133.409C148.673 130.458 147.332 124.556 150.283 120.13C153.234 115.703 159.136 114.362 163.562 117.313L183.146 130.056C187.572 132.872 188.914 138.909 185.963 143.335Z",
    fill: "#D4D9DD"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M165.292 118.331L154.773 134.531L162.761 139.718L173.28 123.518L165.292 118.331Z",
    fill: "#7B828E"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_2630_97984",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 88,
    y: 71,
    width: 51,
    height: 51
  }, _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M113.664 121.337C127.443 121.337 138.613 110.166 138.613 96.3875C138.613 82.6085 127.443 71.4385 113.664 71.4385C99.8855 71.4385 88.7155 82.6085 88.7155 96.3875C88.7155 110.166 99.8855 121.337 113.664 121.337Z",
    fill: "#E4DDFB"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_2630_97984)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M113.664 121.337C127.443 121.337 138.613 110.166 138.613 96.3875C138.613 82.6085 127.443 71.4385 113.664 71.4385C99.8855 71.4385 88.7155 82.6085 88.7155 96.3875C88.7155 110.166 99.8855 121.337 113.664 121.337Z",
    fill: "#EBEDEF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M139.791 73.5665L84.8192 85.251L85.7674 89.7117L140.739 78.0272L139.791 73.5665Z",
    fill: "#EBEDEF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M140.069 84.6935L85.0978 96.3779L86.0459 100.839L141.017 89.1542L140.069 84.6935Z",
    fill: "#EBEDEF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M142.478 95.9591L87.5066 107.644L88.4547 112.104L143.426 100.42L142.478 95.9591Z",
    fill: "#EBEDEF"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.7
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    d: "M96.8973 102.425C95.556 102.693 94.3488 101.888 94.0805 100.547C91.8002 89.8164 98.6411 79.0856 109.506 76.8053C110.847 76.537 112.055 77.3418 112.323 78.6832C112.591 80.0245 111.786 81.2317 110.445 81.5C102.263 83.2438 97.0315 91.2918 98.7752 99.474C99.0435 100.815 98.2387 102.157 96.8973 102.425Z",
    fill: "white"
  }))), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M44.0879 57.25C53.6838 57.25 61.4629 49.4709 61.4629 39.875C61.4629 30.2791 53.6838 22.5 44.0879 22.5C34.4919 22.5 26.7129 30.2791 26.7129 39.875C26.7129 49.4709 34.4919 57.25 44.0879 57.25Z",
    fill: "#1A1C1F"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M48.2128 30.5001C47.5878 30.2501 47.0878 30.5001 46.8378 31.1251C46.5878 31.6251 46.5878 32.2501 47.4628 32.5001C51.3378 34.1251 53.4628 39.0001 51.8378 43.1251C50.0878 47.2501 45.3378 49.3751 41.0878 47.6251C37.0878 46.0001 34.9628 41.6251 36.3378 37.5001L38.0878 38.2501L37.2128 32.6251L32.7128 36.0001L34.3378 36.6251C32.5878 41.7501 35.0878 47.3751 40.2128 49.5001C45.4628 51.6251 51.5878 49.1251 53.7128 43.7501C55.8378 38.7501 53.3378 32.7501 48.2128 30.5001Z",
    fill: "#F9F9F9"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M47.2129 35.5004C47.4629 35.0004 47.2129 34.5004 46.7129 34.2504H46.4629C45.9629 34.0004 45.4629 34.2504 45.2129 34.7504L43.2129 39.7504L39.7129 41.2504C39.2129 41.5004 38.9629 42.1254 39.2129 42.6254C39.4629 43.1254 39.9629 43.3754 40.5879 43.1254L44.4629 41.5004C44.4629 41.5004 44.4629 41.5004 44.5879 41.5004C44.8379 41.3754 44.9629 41.2504 45.0879 41.0004L47.2129 35.5004Z",
    fill: "#F9F9F9"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInProgressImage);
export default __webpack_public_path__ + "static/media/in-progress-image.39f1490c5a1c5f3373f34e277e7cda85.svg";
export { ForwardRef as ReactComponent };